import CryptoJS from "crypto-js";
import {
  clearStorage,
  getItemFromStorage,
  removeItemFromStorage,
} from "./storage";
import { EMPTY_STRING } from "../constants/global.constants";

//Encrypt object for secret key
export const encryptObject = (object) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(object),
    process.env.REACT_APP_SECRET_KEY
  ).toString();
};

//Decrypt object for secret key
export const decryptObject = (encryptedString) => {
  try {
    if (encryptedString !== EMPTY_STRING) {
      const bytes = CryptoJS.AES.decrypt(
        encryptedString,
        process.env.REACT_APP_SECRET_KEY
      );
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      return {};
    }
  } catch (e) {
    removeItemFromStorage(process.env.REACT_APP_PAYLOAD);
    clearStorage();
    window.location.reload();
  }
};

//Decrypt Payload
export const getDecryptPayload = () => {
  const encryptedPayload =
    getItemFromStorage(process.env.REACT_APP_PAYLOAD) || EMPTY_STRING;
  return decryptObject(encryptedPayload);
};

//Get token for decrypt payload
export const getToken = () => {
  return getDecryptPayload()[process.env.REACT_APP_TOKEN];
};

// Decrypt user role
export const getDecryptUserRole = () => {
  const encryptedPayload =
    getItemFromStorage(process.env.REACT_APP_USER_ROLE) || EMPTY_STRING;
  return decryptObject(encryptedPayload);
};
